import { gql } from 'apollo-angular';

export const SEND_MESSAGE = gql`
  query getChatResponse($input: ChatInput!) {
    getChatResponse(input: $input) {
      message
    }
  }
`;
